import styled from 'styled-components';


const MissingFlagPlaceholder = styled.div<{ size: string }>`
  width: ${({ size }) => (`${size}`)};
  height: ${({ size }) => (`${size}`)};
`;


export default { MissingFlagPlaceholder };
